<template>
  <v-layout v-if="screener" row wrap>
    <v-flex xs12 md6>
      <v-card flat class="border-grey-all" min-height="310px">
        <v-card-text>
          <div class="title pb-4">
            <b>{{ $t("screener.free_type.title") }}</b>
          </div>
          <div class="display-1">
            {{ DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL }}0
          </div>
          <div
            v-if="screener.screening_type == DEFINES.SCREENING_PLAN_TYPE.FREE"
            class="title greyDarken1--text py-3"
          >
            <v-icon>check</v-icon>
            {{ $t("screener.current_plan.title") }}
          </div>
          <div>
            <p class="mb-2">
              <b>{{ $t("screener.free_features.title") }}</b>
            </p>

            <p class="mb-2">
              {{ $t("screener.free_type.feature.1") }}
            </p>
            <p class="mb-2">{{ $t("screener.free_type.feature.2") }}</p>
            <p class="mb-0">{{ $t("screener.free_type.feature.3") }}</p>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-flex xs12 md6>
      <v-card flat class="border-grey-all" min-height="310px">
        <v-card-text>
          <div class="title pb-4">
            <b>{{ $t("screener.premium_type.title") }}</b>
          </div>
          <div class="display-1">
            {{ DEFINES.PREMIUM_SCREENING_BASE_CURRENCY_SYMBOL
            }}{{ DEFINES.PREMIUM_SCREENING_BASE_CHARGEABLE_AMOUNT }}
          </div>
          <div class="title greyDarken1--text py-3">
            <div
              v-if="
                screener.screening_type == DEFINES.SCREENING_PLAN_TYPE.PREMIUM
              "
            >
              <v-icon>check</v-icon>
              Current Plan
            </div>
            <v-btn
              v-else
              color="primary"
              class="pa-4"
              block
              x-large
              dark
              @click="$emit('onUpgrade', 2)"
              >{{ $t("screener.upgrade.title") }}</v-btn
            >
          </div>
          <div>
            <p class="mb-2">
              <b>{{ $t("screener.premium_features.title") }}</b>
            </p>

            <p class="mb-0">{{ $t("screener.premium_type.feature.1") }}</p>
          </div>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "ScreenerPlans",
  props: {
    screener: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style>
</style>
